import React, { useEffect, useState } from "react";
import { Badge, ListPage, TableSkeleton } from "@redipos/ui";
import { plataformaApi, type AdminTeamMemberRow } from "../api.js";

/**
 * Equipo interno del ERP. Hoy solo lectura — dar de alta/gestionar roles
 * internos (admin:*) es la fase final del plan de RBAC, ver
 * docs/analisis/consola-admin-rediseno.md §5/§7 fase 8.
 */
export default function TeamPage() {
  const [rows, setRows] = useState<AdminTeamMemberRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    plataformaApi
      .equipo()
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ListPage title="Equipo interno" subtitle="Quién tiene acceso al ERP y con qué rol.">
      {loading ? (
        <TableSkeleton rows={4} cols={4} />
      ) : (
        <div className="rounded-input border border-border overflow-hidden">
          <div className="table-x-scroll max-w-full">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-fg-subtle text-xs uppercase bg-surface-elevated">
                  <th className="px-3 py-2 font-medium">Usuario</th>
                  <th className="px-3 py-2 font-medium">Correo</th>
                  <th className="px-3 py-2 font-medium">Rol</th>
                  <th className="px-3 py-2 font-medium">Estado</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-3 py-6 text-center text-fg-subtle">
                      Sin miembros
                    </td>
                  </tr>
                ) : (
                  rows.map((r) => (
                    <tr key={r.id} className="text-fg-muted">
                      <td className="px-3 py-2 text-fg">{r.usuario}</td>
                      <td className="px-3 py-2 break-all">{r.email}</td>
                      <td className="px-3 py-2">{r.rol}</td>
                      <td className="px-3 py-2">
                        {r.isActive ? <Badge variant="success">Activo</Badge> : <Badge variant="danger">Inactivo</Badge>}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </ListPage>
  );
}
